import {Component, OnDestroy, OnInit} from '@angular/core';
import {GeneralService} from "../../../../services/generalService";
import {RouteService} from "../../../../services/routeService";
import {NotificationService} from "../../../../services/notificationService";
import {DICTIONARY} from "../../../../dictionary";
import _ from "lodash";
import {AuthService} from "../../../../services/authService";
import {Router} from "@angular/router";
import util from "util";


@Component({
  selector: 'app-collaboration-protection-configuration',
  templateUrl: './collaboration-protection-configuration.component.html',
  styleUrls: ['./collaboration-protection-configuration.component.scss']
})
export class CollaborationProtectionConfigurationComponent implements OnInit, OnDestroy {
	constructor(private router:Router,
				private gs:GeneralService,
				private rs:RouteService,
				private ns:NotificationService,
				private authService:AuthService) {
	}

	_=_;
	dic = DICTIONARY;
	config;
	isThisFeatureSupported;
	actionInProcess;
	userInfo;
	mailboxes = [];
	isMailboxesError = false;
	isProtectionScopeCompleted = false;
	isHistoricalScanCompleted = false;
	historicalScanInProcess = false;
	protectionScope: 'all' | 'specific';
	protectionScopeChanged = false;
	syncPollTimeout;
	cloudCredentialsPopup;
	selectedServerEndpoint = _.clone(DICTIONARY.CONSTANTS.exchangeServerEndpoints.Global);

	ngOnInit() {
		this.gs.getUserInfo(false, (userInfo) => {
			this.userInfo = userInfo;
		});

		this.getCollaborationConfiguration();
	}

	getCollaborationConfiguration = () => {
		return this.rs.getCollaborationConfiguration().then((response) => {
			this.config = response;
			this.isThisFeatureSupported = true;
			this.selectedServerEndpoint = _.clone(
				_.find(this.dic.CONSTANTS.exchangeServerEndpoints, endpoint => endpoint.name === this.config.cloudEndpointName) ||
				_.find(this.dic.CONSTANTS.exchangeServerEndpoints, endpoint => endpoint.AzureAD === this.config.azEndpoint && endpoint.MSGraphAPI === this.config.graphEndpoint) ||
				this.dic.CONSTANTS.exchangeServerEndpoints.Global
			);

			this.protectionScope = this.config.collaboration_protection.microsoft?.protect_all ? 'all' : 'specific';
			this.checkProtectionScopeCompleted();

			if (this.config.collaboration_protection.microsoft?.enabled) {
				this.checkResourcesSync();
				this.checkHistoryScanSync();
			}

		}, (err) => {
			if (err?.data?.message && err.data.message.includes('This feature is not supported')) {
				this.isThisFeatureSupported = false;
			}
		});
	}

	checkResourcesSync = () => {
		this.rs.getCollaborationConfiguration().then((response) => {
			this.config.collaboration_protection.microsoft.sync_mode = response.collaboration_protection.microsoft.sync_mode;
			if (!this.config.collaboration_protection.microsoft.sync_mode) {
				this.config.collaboration_protection.microsoft.sync_mode = 'init';
			}
			if (this.config.collaboration_protection.microsoft.sync_mode !== 'done') {
				this.syncPollTimeout = setTimeout(() => {
					this.checkResourcesSync();
				}, 4000);
			}
			else {
				this.getCollaborationUsersMailboxes();
			}
		}, (err) => {
		});
	}

	startHistoryScan = () => {
		if (this.historicalScanInProcess) {
			return;
		}

		this.gs.showPopup({
			title: 'Start Historical Scan',
			subTitle: 'Note: You are about to initiate a scan on all resources from the past 7 days and activate the protection.',
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: 'Run',
			doneCb: () => {
				this.actionInProcess = true;
				const actionInfo = {
					action: 'historicalScan',
				};
				this.rs.configureMicrosoftCollaboration(actionInfo).then(() => {
					this.actionInProcess = false;
					this.historicalScanInProcess = true;
					this.checkHistoryScanSync();
					// this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
				}, () => {
					this.actionInProcess = false;
				});
			}
		});
	}

	skipHistoryScan = () => {
		if (this.historicalScanInProcess) {
			return;
		}

		this.gs.showPopup({
			title: 'Skip Historical Scan',
			subTitle: 'Are you sure you want to skip the historical scan?',
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: 'Skip',
			doneCb: () => {
				this.actionInProcess = true;
				const actionInfo = {
					action: 'historicalScan',
					type: 'skip',
				};
				this.rs.configureMicrosoftCollaboration(actionInfo).then(() => {
					this.actionInProcess = false;
					this.config.collaboration_protection.microsoft.historical_scan = {
						status: 'skip'
					};
					this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
				}, () => {
					this.actionInProcess = false;
				});
			}
		});
	}

	checkHistoryScanSync = () => {
		this.rs.getCollaborationConfiguration().then((response) => {
			this.config.collaboration_protection.microsoft.historical_scan = response.collaboration_protection.microsoft.historical_scan;

			this.isHistoricalScanCompleted = this.config.collaboration_protection.microsoft.historical_scan?.status === 'completed' || this.config.collaboration_protection.microsoft.historical_scan?.status === 'skip';
			this.historicalScanInProcess = this.config.collaboration_protection.microsoft.historical_scan?.status === 'running';

			if (this.config.collaboration_protection.microsoft.historical_scan?.status && !this.isHistoricalScanCompleted) {
				this.syncPollTimeout = setTimeout(() => {
					this.checkHistoryScanSync();
				}, 4000);
			}
		}, (err) => {
		});
	}

	checkProtectionScopeCompleted = () => {
		this.isProtectionScopeCompleted = this.config.collaboration_protection.microsoft?.protect_all || this.mailboxes.some(mailbox => mailbox.is_protected);
	}

	getCollaborationUsersMailboxes = () => {
		this.rs.getCollaborationUsersMailboxes().then((response) => {
			this.mailboxes = response || [];
			this.mailboxes.forEach(mailbox => {
				mailbox.selected = !!mailbox.is_protected;
				mailbox.displayName = mailbox.name ? `${mailbox.name} <${mailbox.email}>` : mailbox.email;

				this.isProtectionScopeCompleted = this.isProtectionScopeCompleted || !!mailbox.is_protected;
			});
		}, (err) => {
		});
	}

	ngOnDestroy() {
		clearTimeout(this.syncPollTimeout);
	}

	changeEndpoint = (endpoint) => {
		if (this.actionInProcess || this.config.exchangeConnected) {
			return;
		}
		const usesCustomCredentials = [this.dic.CONSTANTS.exchangeServerEndpoints.USGovernmentGCCHigh.name, this.dic.CONSTANTS.exchangeServerEndpoints.USGovernmentDoD.name, this.dic.CONSTANTS.exchangeServerEndpoints.China.name, this.dic.CONSTANTS.exchangeServerEndpoints.SingleTenantApp.name].includes(endpoint.name);
		if (this.selectedServerEndpoint.name === endpoint.name && !usesCustomCredentials) {
			return;
		}
		if (usesCustomCredentials) {
			const microsoft = this.config.collaboration_protection.microsoft || {};
			this.cloudCredentialsPopup = {
				show: true,
				applyInProcess: false,
				endpoint,
				clientIdInput: microsoft.client_id || '',
				clientSecretInput: '',
				clientSecretSet: !!microsoft.client_secret_set
			};
			return;
		}

		this.saveCloudAPIEndpoint({name: endpoint.name});
	}

	saveSovereignCloud = () => {
		const popup = this.cloudCredentialsPopup;
		const microsoft = this.config.collaboration_protection.microsoft || {};
		const sameCloud = microsoft.endpoint_name === popup.endpoint.name;
		if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(popup.clientIdInput?.trim() || '')) {
			return this.ns.showErrorMessage('Client ID must be a valid GUID.');
		}
		if (!popup.clientSecretInput && (!popup.clientSecretSet || !sameCloud || microsoft.client_id?.toLowerCase() !== popup.clientIdInput?.trim().toLowerCase())) {
			return this.ns.showErrorMessage('Enter the Collab client secret for this cloud and app registration.');
		}

		this.saveCloudAPIEndpoint({
			name: popup.endpoint.name,
			client_id: popup.clientIdInput.trim().toLowerCase(), client_secret: popup.clientSecretInput
		});
	}

	saveCloudAPIEndpoint = (endpoint, confirmed = false) => {
		if (this.actionInProcess || this.config.exchangeConnected) {
			return;
		}
		const microsoft = this.config.collaboration_protection.microsoft || {};
		const cloud = _.find(this.dic.CONSTANTS.exchangeServerEndpoints, item => item.name === endpoint.name);
		const resetCloudState = (this.config.graphEndpoint || this.selectedServerEndpoint.MSGraphAPI) !== cloud.MSGraphAPI
			|| (this.config.azEndpoint || this.selectedServerEndpoint.AzureAD) !== cloud.AzureAD
			|| (microsoft.endpoint_name === this.dic.CONSTANTS.exchangeServerEndpoints.SingleTenantApp.name && microsoft.endpoint_name !== endpoint.name)
			|| !!(endpoint.client_id && (microsoft.endpoint_name !== endpoint.name || microsoft.client_id?.toLowerCase() !== endpoint.client_id.trim().toLowerCase()));
		if (resetCloudState && !confirmed) {
			// CC: taken from collaboration-protection-configuration.component.ts -> disconnectMicrosoft
			this.gs.showPopup({
				title: 'Change Microsoft Cloud',
				subTitle: 'Changing the Microsoft cloud or main app registration will disable collaboration protection and reset scan progress and quarantine setup.',
				body: [
					'Reconnect Microsoft 365 and set up quarantine after saving.',
					'Quarantined files will remain in the previous cloud. Review or release them before continuing.',
					'Policies, protected user selections, and incident history will be kept.'
				],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Change Cloud',
				doneCb: () => this.saveCloudAPIEndpoint(endpoint, true)
			});
			return;
		}
		const popup = this.cloudCredentialsPopup;
		if (popup) {
			popup.applyInProcess = true;
		}
		this.actionInProcess = true;
		return this.rs.configureMicrosoftCollaboration({action: 'cloudAPIEndpoint', endpoint}).then(() => this.getCollaborationConfiguration()).then(() => {
			if (popup) {
				popup.show = false;
				popup.applyInProcess = false;
			}
			this.actionInProcess = false;
			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
		}, () => {
			if (popup) {
				popup.applyInProcess = false;
			}
			this.actionInProcess = false;
		});
	}

	connectMicrosoft = async () => {
		this.actionInProcess = true;
		if (this.config.exchangeConnected) {
			try {
				await this.rs.configureMicrosoftCollaboration({action: 'cloudAPIEndpoint'});
			}
			catch (err) {
				this.actionInProcess = false;
				return;
			}
		}
		const azEndpoint = this.config.azEndpoint || DICTIONARY.CONSTANTS.exchangeServerEndpoints.Global.AzureAD;
		this.authService.authMicrosoftExchangeAdmin(this.userInfo.email, azEndpoint, this.config.exchangeCollabAppId, 'collab', this.config.tenantId, (err) => {
			if (err) {
				if (err !== true) {
					err = err.replace('Sign in failed', 'Exchange API authentication failed');
					this.ns.showErrorMessage('Failed to run Collaboration Protection. ' + (err || 'Error'));
					this.actionInProcess = false;
				}
				return;
			}

			this.rs.configureMicrosoftCollaboration({action: 'enabled'}).then(() => {
				this.actionInProcess = false;
				this.config.collaboration_protection.microsoft.enabled = true;
				console.log('configureMicrosoftCollaboration done');
				this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
				window.location.reload();
			}, (err) => {
				this.actionInProcess = false;
				this.config.collaboration_protection.microsoft.enabled = false;
			});
		});
	}

	reauthenticateMicrosoft = async () => {
		this.actionInProcess = true;
		if (this.config.exchangeConnected) {
			try {
				await this.rs.configureMicrosoftCollaboration({action: 'cloudAPIEndpoint'});
			}
			catch (err) {
				this.actionInProcess = false;
				return;
			}
		}
		const azEndpoint = this.config.azEndpoint || DICTIONARY.CONSTANTS.exchangeServerEndpoints.Global.AzureAD;
		this.authService.authMicrosoftExchangeAdmin(this.userInfo.email, azEndpoint, this.config.exchangeCollabAppId, 'collab', this.config.tenantId, (err) => {
			if (err) {
				if (err !== true) {
					err = err.replace('Sign in failed', 'Exchange API authentication failed');
					this.ns.showErrorMessage('Failed to run Collaboration Protection. ' + (err || 'Error'));
					this.actionInProcess = false;
				}
				return;
			}

			this.actionInProcess = false;
			console.log('configureMicrosoftCollaboration done');
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		});
	}

	disconnectMicrosoft = () => {
		this.gs.showPopup({
			title: 'Disconnect Microsoft 365',
			subTitle: 'Collaboration protection will be disabled for all Microsoft 365 resources and users.',
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Disconnect',
			doneCb: () => {
				this.actionInProcess = true;
				this.rs.configureMicrosoftCollaboration({action: 'disabled'}).then(() => {
					this.actionInProcess = false;
					this.config.collaboration_protection.microsoft.enabled = false;
					this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
				}, () => {
					this.actionInProcess = false;
				});
			}
		});
	}

	syncStepOrder = ['chat', 'channel', 'site', 'done'];

	getSyncStepState(step: string): 'done' | 'active' | 'pending' {
		const syncMode = this.config?.collaboration_protection?.microsoft?.sync_mode;
		if (!syncMode) return 'pending';
		const currentIdx = this.syncStepOrder.indexOf(syncMode);
		const stepIdx = this.syncStepOrder.indexOf(step);
		if (currentIdx > stepIdx) return 'done';
		if (currentIdx === stepIdx) return 'active';
		return 'pending';
	}

	saveProtectionScope = () => {
		if (this.actionInProcess) {
			return;
		}
		this.actionInProcess = true;

		if (this.protectionScope === 'specific' && !this.mailboxes.some(mailbox => mailbox.selected)) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.selectAtLeastOneX, 'user'));
			this.isMailboxesError = true;
			this.actionInProcess = false;
			return;
		}

		const actionInfo = {
			action: 'protectionScope',
			enabled: this.protectionScope === 'all',
		};
		this.rs.configureMicrosoftCollaboration(actionInfo).then(() => {
			this.config.collaboration_protection.microsoft.protect_all = actionInfo.enabled;
			this.ns.showInfoMessage(this.dic.MESSAGES.protectionScopeChanged);

			this.protectionScopeChanged = false;

			if (this.config.collaboration_protection.microsoft.protect_all) {
				this.checkProtectionScopeCompleted();
			}
			else {
				this.changeMailboxesProtectState();
			}

			this.isProtectionScopeCompleted = true;
			this.actionInProcess = false;
		}, () => {
			this.actionInProcess = false;
		});
	}

	changeMailboxesProtectState = () => {
		const mailboxesToChange = this.mailboxes.filter(mailbox => mailbox.selected !== mailbox.is_protected);

		mailboxesToChange.forEach(mailbox => {
			const actionInfo = {
				action: mailbox.selected ? this.dic.CONSTANTS.collaborationMailboxAction.enable.value : this.dic.CONSTANTS.collaborationMailboxAction.disable.value
			};
			this.rs.configureCollaborationMailbox(mailbox.email, actionInfo).then((response) => {
				mailbox.is_protected = mailbox.selected;
			}, (err) => {
			});
		});
	}

	goToUsersPage = () => {
		this.router.navigate([this.dic.CONSTANTS.appStates.collaborationProtection, this.dic.CONSTANTS.collaborationProtectionUsersTabs.users]);
	}

	goToOverviewPage = () => {
		this.router.navigate([this.dic.CONSTANTS.appStates.collaborationProtection, this.dic.CONSTANTS.adminPages.collaborationProtection.overview]);
		setTimeout(() => {
			document.getElementById('main').scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}, 100)
	}
}
